<script setup lang="ts">
  import type { SearchFunctionMap } from '@gat-ship/types'
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    useDialogZIndex
  } from '@gat-ship/vue-components'
  import { useGlobalSearchDialog } from '../composables/global-search-context'
  import GlobalSearchCommand from './GlobalSearchCommand.vue'

  defineProps<{ searchFunctions?: SearchFunctionMap }>()

  const { isSearchCommandOpen, closeSearchCommand } = useGlobalSearchDialog()

  // Floats above whatever central-modal-host stack entry (or transient
  // overlay) is currently on top, so ctrl+K always surfaces the search
  // dialog even when another modal is already open. See `useDialogZIndex`.
  const { zIndex } = useDialogZIndex(isSearchCommandOpen)

  function onOpenChange(open: boolean) {
    if (!open) {
      closeSearchCommand()
    }
  }
</script>

<template>
  <Dialog :open="isSearchCommandOpen" @update:open="onOpenChange">
    <DialogContent
      class="top-[15%] max-w-2xl translate-y-0 gap-0 overflow-hidden p-0 sm:max-w-2xl"
      hide-close-button
      :overlay-z-index="zIndex"
    >
      <DialogHeader class="sr-only">
        <DialogTitle>Global search</DialogTitle>
        <DialogDescription>
          Search across clients, vendors, contacts and navigation
        </DialogDescription>
      </DialogHeader>
      <!-- Mounted on open (Presence-gated): the search session lives and
           dies with this subtree, so every open starts fresh. -->
      <GlobalSearchCommand :search-functions="searchFunctions" />
    </DialogContent>
  </Dialog>
</template>
